<template>
  <dummy-scout-form
    :is-modified="!!isReviewSaved"
    data-test="is-review-saved"
    label="行動ターゲティング"
  >
    <div class="boss-layout boss-layout-start">
      <label
        class="boss-checkbox"
      >
        <input
          v-model="isReviewSaved"
          class="boss-input-checkbox"
          type="checkbox"
        >この求人を気になるリストに保存している会員
      </label>
    </div>
  </dummy-scout-form>
</template>

<script>
import DummyScoutForm from '@/components/atoms/DummyScoutForm'

export default {
  components: {
    DummyScoutForm
  },
  data () {
    return {
      isReviewSaved: false
    }
  }
}
</script>
